import { IContext } from "@src/context";
import "./index.css";

import { defineMessages } from "@formatjs/intl";

const messages = defineMessages({
  text: {
    id: "Loading.findProperties",
    defaultMessage: "Finding Properties",
  },
});
export function setupLoading(context: IContext) {
  function renderText() {
    const textEle = document.querySelector(".element-loading-text");
    if (!textEle) return;
    textEle.textContent = context.intl.formatMessage(messages.text);
  }

  renderText();
}
